import { __decorate } from "tslib";
import { Options, Vue } from "vue-class-component";
import MySkillsSect from "@/components/sections/MySkillsSect.vue";
let MySkills = class MySkills extends Vue {
    data() {
        return {
            skills_types: ["frontend", "task-runner", "wordpress", "bundler", "backend"],
        };
    }
};
MySkills = __decorate([
    Options({
        components: {
            MySkillsSect,
        },
        data() {
            return {
                urlImg: "~@/assets/images/skills.png",
            };
        },
        mounted() {
            console.log("mounted");
        },
        computed: {
            site_data() {
                return this.$store.state.site_data;
            },
        },
    })
], MySkills);
export default MySkills;
